/**
 * @generated SignedSource<<61191c0f359b5d45537445895aa904e3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type applyAccessCodeMutation$variables = {
  code: string;
};
export type applyAccessCodeMutation$data = {
  readonly applyAccessCode: {
    readonly data: {
      readonly beginStartDate: string | null;
      readonly bundleId: string | null;
      readonly bundleName: string | null;
      readonly bundleNumericId: number | null;
      readonly bundleType: string | null;
      readonly content: string | null;
      readonly endStartDate: string | null;
      readonly examId: string | null;
      readonly examName: string | null;
      readonly expiryDate: string | null;
      readonly features: ReadonlyArray<string | null> | null;
      readonly icon: string | null;
      readonly isCustomAccess: boolean | null;
      readonly planLength: string | null;
    } | null;
    readonly isSameEmail: boolean | null;
    readonly message: string;
    readonly productData: ReadonlyArray<{
      readonly beginStartDate: string | null;
      readonly bundleId: string | null;
      readonly bundleName: string | null;
      readonly bundleNumericId: number | null;
      readonly bundleType: string | null;
      readonly endStartDate: string | null;
      readonly examId: string | null;
      readonly examName: string | null;
      readonly expiryDate: string | null;
      readonly features: ReadonlyArray<string | null> | null;
      readonly icon: string | null;
      readonly isCustomAccess: boolean | null;
      readonly planLength: string | null;
    } | null> | null;
    readonly success: boolean;
  };
};
export type applyAccessCodeMutation = {
  response: applyAccessCodeMutation$data;
  variables: applyAccessCodeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "code"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bundleId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bundleNumericId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "examName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bundleType",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bundleName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "planLength",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expiryDate",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "examId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "features",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCustomAccess",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "beginStartDate",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endStartDate",
  "storageKey": null
},
v14 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "code",
        "variableName": "code"
      }
    ],
    "concreteType": "AccessCodeResult",
    "kind": "LinkedField",
    "name": "applyAccessCode",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isSameEmail",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ApplyCodeSuccessData",
        "kind": "LinkedField",
        "name": "data",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "content",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ApplyCodeSuccessData",
        "kind": "LinkedField",
        "name": "productData",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "applyAccessCodeMutation",
    "selections": (v14/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "applyAccessCodeMutation",
    "selections": (v14/*: any*/)
  },
  "params": {
    "cacheID": "b2b91642cca93a8759c957e284ac1029",
    "id": null,
    "metadata": {},
    "name": "applyAccessCodeMutation",
    "operationKind": "mutation",
    "text": "mutation applyAccessCodeMutation(\n  $code: String!\n) {\n  applyAccessCode(code: $code) {\n    success\n    isSameEmail\n    message\n    data {\n      bundleId\n      bundleNumericId\n      examName\n      bundleType\n      bundleName\n      planLength\n      expiryDate\n      icon\n      examId\n      features\n      isCustomAccess\n      beginStartDate\n      endStartDate\n      content\n    }\n    productData {\n      bundleId\n      bundleNumericId\n      examName\n      bundleType\n      bundleName\n      planLength\n      expiryDate\n      icon\n      examId\n      features\n      isCustomAccess\n      beginStartDate\n      endStartDate\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a43a086a87aebab4fb1a6b1ae7f1f74b";

export default node;
